import * as React from "react";
import { TextInput, ReferenceArrayInput } from "react-admin";
import Transformer from "../../../common/Transformer";
import { StickerEditComponent } from "src/resources/product/sticker";
import { Edit, SimpleForm } from "src/enterprise/ra-rbac";
import { Grid } from "@mui/material";
import { FileInput } from "../../../components/file-input/FileInput";

export const StickerEdit = () => {
  const transform = (data) => {
    Transformer(data, {
      remove: ["id", "createdAt", "updatedAt"],
      update: {},
    });

    return data;
  };

  return (
    <Edit
      component={StickerEditComponent}
      mutationMode="pessimistic"
      transform={transform}
      actions={null}
    >
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} lg={6}>
            <TextInput disabled source="id" />
          </Grid>
          <Grid item sm={12} lg={6}>
            <TextInput source="name" required />
          </Grid>
          <Grid item sm={12} lg={6}>
            <FileInput
              source="image"
              fileTypes={["JPG", "JPEG", "PNG", "GIF", "WEBP", "PDF", "XLS", "XLSX", "DOCX"]}
              multiple={false}
            />
          </Grid>
        </Grid>
      </SimpleForm>
    </Edit>
  );
};
